<template>
  <div class="wg-row motorsport-plugin">
    <div class="wg-row motorsport-field">
      <img :src="$anm22.icons.getWorldIcon('motorsport')" class="label-ic" />
      <select
        :disabled="!editMode"
        v-model="motorsportCategory"
        @change="save('motorsportCategory')"
        class="com-anm22-app-select"
      >
        <option>
          {{
            $anm22.strLang(
              lang,
              "Select event category",
              "Seleziona categoria evento"
            )
          }}
        </option>
        <option
          v-for="(category, categoryKey) in categories"
          :key="categoryKey"
          :value="category.id"
        >
          {{ category.name }}
        </option>
      </select>
    </div>
    <div class="wg-row motorsport-field">
      <img :src="$anm22.icons.getWorldIcon('placeBlack')" class="label-ic" />
      <input
        :disabled="!editMode"
        type="text"
        v-model="motorsportCircuitName"
        @change="save('motorsportCircuitName')"
        :placeholder="
          $anm22.strLang(lang, 'Add circuit name', 'Aggiungi nome circuito')
        "
      />
    </div>
    <div class="wg-row motorsport-field">
      <img :src="$anm22.icons.getWorldIcon('map')" class="label-ic" />
      <input
        :disabled="!editMode"
        type="text"
        v-model="motorsportCircuitLayoutMap"
        @change="save('motorsportCircuitLayoutMap')"
        :placeholder="
          $anm22.strLang(
            lang,
            'Add circuit layout image URL',
            'Aggiungi URL immagine layout circuito'
          )
        "
      />
    </div>
    <div class="wg-row motorsport-field">
      <img :src="$anm22.icons.getWorldIcon('map')" class="label-ic" />
      <input
        :disabled="!editMode"
        type="text"
        v-model="motorsportPaddockMap"
        @change="save('motorsportPaddockMap')"
        :placeholder="
          $anm22.strLang(
            lang,
            'Add paddock map image URL',
            'Aggiungi URL immagine mappa paddock'
          )
        "
      />
    </div>
    <div class="wg-row motorsport-field">
      <img :src="$anm22.icons.getWorldIcon('timer')" class="label-ic" />
      <input
        :disabled="!editMode"
        type="text"
        v-model="liveTimingWebsite"
        @change="save('liveTimingWebsite')"
        :placeholder="
          $anm22.strLang(
            lang,
            'Add live timing website',
            'Aggiungi sito live timing'
          )
        "
      />
    </div>
    <div class="wg-row motorsport-field">
      <img :src="$anm22.icons.getWorldIcon('timer')" class="label-ic" />
      <input
        :disabled="!editMode"
        type="text"
        v-model="perugiaTimingSessionId"
        @change="save('perugiaTimingSessionId')"
        :placeholder="
          $anm22.strLang(
            lang,
            'Add Perugia Timing session ID',
            'Aggiungi ID sessione Perugia Timing'
          )
        "
      />
    </div>
    <div class="wg-row motorsport-field">
      <img :src="$anm22.icons.getWorldIcon('ticket')" class="label-ic" />
      <input
        :disabled="!editMode"
        type="text"
        v-model="ticketsWebsite"
        @change="save('ticketsWebsite')"
        :placeholder="
          $anm22.strLang(
            lang,
            'Add tickets website',
            'Aggiungi sito acquisto biglietti'
          )
        "
      />
    </div>
    <div class="wg-row motorsport-field">
      <img :src="$anm22.icons.getWorldIcon('photoCamera')" class="label-ic" />
      <input
        :disabled="!editMode"
        type="text"
        v-model="titleSponsorLogo"
        @change="save('titleSponsorLogo')"
        :placeholder="
          $anm22.strLang(
            lang,
            'Add title sponsor image URL',
            'Aggiungi URL immagine title sponsor'
          )
        "
      />
    </div>
    <div class="wg-row motorsport-field">
      <img :src="$anm22.icons.getWorldIcon('photoCamera')" class="label-ic" />
      <input
        :disabled="!editMode"
        type="text"
        v-model="titleSponsorWebsite"
        @change="save('titleSponsorWebsite')"
        :placeholder="
          $anm22.strLang(
            lang,
            'Add title sponsor website',
            'Aggiungi sito title sponsor'
          )
        "
      />
    </div>
    <div class="wg-row motorsport-field">
      <img :src="$anm22.icons.getWorldIcon('sportsScore')" class="label-ic" />
      <input
        :disabled="!editMode"
        type="text"
        v-model="resultsWebsite"
        @change="save('resultsWebsite')"
        :placeholder="
          $anm22.strLang(
            lang,
            'Add results website',
            'Aggiungi link ai risultati'
          )
        "
      />
    </div>
    <div class="wg-row motorsport-field">
      <img :src="$anm22.icons.getWorldIcon('workMaterial')" class="label-ic" />
      <input
        :disabled="!editMode"
        type="text"
        v-model="googleMapsLink"
        @change="save('googleMapsLink')"
        :placeholder="
          $anm22.strLang(
            lang,
            'Add Google Maps location link',
            'Aggiungi URL scheda Google Maps'
          )
        "
      />
    </div>
    <div class="wg-row motorsport-field">
      <img :src="$anm22.icons.getWorldIcon('map')" class="label-ic" />
      <input
        :disabled="!editMode"
        type="text"
        v-model="googleMapsPreview"
        @change="save('googleMapsPreview')"
        :placeholder="
          $anm22.strLang(
            lang,
            'Add Google Maps preview image URL',
            'Aggiungi URL immagine anteprima Google Maps'
          )
        "
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    event: {
      type: Object,
      default: null,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      motorsportCategory:
        this.event.jsonData && this.event.jsonData.motorsportCategory
          ? this.event.jsonData.motorsportCategory
          : "",
      motorsportCircuitName:
        this.event.jsonData && this.event.jsonData.motorsportCircuitName
          ? this.event.jsonData.motorsportCircuitName
          : "",
      motorsportCircuitLayoutMap:
        this.event.jsonData && this.event.jsonData.motorsportCircuitLayoutMap
          ? this.event.jsonData.motorsportCircuitLayoutMap
          : "",
      motorsportPaddockMap:
        this.event.jsonData && this.event.jsonData.motorsportPaddockMap
          ? this.event.jsonData.motorsportPaddockMap
          : "",
      liveTimingWebsite:
        this.event.jsonData && this.event.jsonData.liveTimingWebsite
          ? this.event.jsonData.liveTimingWebsite
          : "",
      perugiaTimingSessionId:
        this.event.jsonData && this.event.jsonData.perugiaTimingSessionId
          ? this.event.jsonData.perugiaTimingSessionId
          : "",
      ticketsWebsite:
        this.event.jsonData && this.event.jsonData.ticketsWebsite
          ? this.event.jsonData.ticketsWebsite
          : "",
      titleSponsorLogo:
        this.event.jsonData && this.event.jsonData.titleSponsorLogo
          ? this.event.jsonData.titleSponsorLogo
          : "",
      titleSponsorWebsite:
        this.event.jsonData && this.event.jsonData.titleSponsorWebsite
          ? this.event.jsonData.titleSponsorWebsite
          : "",
      resultsWebsite:
        this.event.jsonData && this.event.jsonData.resultsWebsite
          ? this.event.jsonData.resultsWebsite
          : "",
      googleMapsLink:
        this.event.jsonData && this.event.jsonData.googleMapsLink
          ? this.event.jsonData.googleMapsLink
          : "",
      googleMapsPreview:
        this.event.jsonData && this.event.jsonData.googleMapsPreview
          ? this.event.jsonData.googleMapsPreview
          : "",
      categories: [
        {
          id: "civ",
          name: "CIV",
        },
        {
          id: "coppa-italia",
          name: "Coppa Italia",
        },
        {
          id: "civ-junior",
          name: "CIV Junior",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
    }),
  },
  methods: {
    save(propertyName) {
      this.$emit("updateEventDataProperty", propertyName, this[propertyName], true);
    },
  },
};
</script>

<style lang="scss" scoped>
.motorsport-plugin {
  border-bottom: 1px solid rgba(0, 0, 0, 0.26);
  padding: 12px 0;

  .motorsport-field {
    display: flex;
    align-items: center;
    padding: 5px 0;

    .label-ic {
      width: 20px;
      height: 20px;
      margin-right: 6px;
    }

    input {
      flex: 1;
      max-width: unset;
    }
  }
}
</style>
